// /patient/wizard — VitaMed Helper chat card. Text-only — no audio /
// recording controls per product spec.
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { doctorLabel, usePatientData } from "./PatientDataContext";
import { HELPER_QUICK_PROMPTS } from "./patientMockData";

export default function PatientWizard() {
  const { rows } = usePatientData();
  const doctor = doctorLabel(rows[0] || {});
  const [draft, setDraft] = useState("");

  const onSubmit = (e) => {
    e.preventDefault();
    setDraft("");
  };

  return (
    <>
      <div className="pp-page-head">
        <Link to="." className="pp-back-link">‹ Home</Link>
        <h1 className="pp-page-title">VitaMed Helper</h1>
        <div className="pp-page-sub">Tap a quick action or type your question below</div>
      </div>

      <div className="pp-card pp-helper">
        <p className="pp-detail-p" style={{ marginBottom: 10 }}>
          Hi, I can help you with anything in the app. Just talk to me like a
          person — I'll take care of the buttons.
        </p>

        <div className="pp-helper-quick">
          {HELPER_QUICK_PROMPTS.map((p) => (
            <Link key={p.label} to={p.to} className="pp-helper-chip">
              <span className="pp-helper-chip-icon">{p.icon}</span>
              <span>{p.label}</span>
            </Link>
          ))}
        </div>

        <div className="pp-chat">
          <div className="pp-chat-msg pp-chat-msg-user">
            Did I take my heart medicine this morning?
          </div>
          <div className="pp-chat-msg pp-chat-msg-bot">
            Yes — you marked your <strong>lisinopril 20 mg</strong> as taken at
            7:42 AM today, with breakfast. Your <strong>atorvastatin 40 mg</strong>{" "}
            is also done. You still have one to take tonight: metoprolol at
            bedtime.
          </div>
          <div className="pp-chat-msg pp-chat-msg-user">
            Can you tell Dr. Pallickal my chest hasn't hurt this week?
          </div>
          <div className="pp-chat-msg pp-chat-msg-bot">
            I drafted this message to <strong>{doctor}</strong>: "No chest pain
            this week. Continuing all medicines as prescribed." Tap{" "}
            <strong>Send</strong> to confirm, or tell me what to change.
          </div>
          <Link
            to="message"
            className="pp-btn pp-teal"
            style={{ alignSelf: "flex-start", marginTop: 4 }}
          >
            ✓ Open message
          </Link>
        </div>

        <form className="pp-helper-input" onSubmit={onSubmit}>
          <input
            type="text"
            placeholder="Ask the VitaMed Helper anything…"
            aria-label="Ask the VitaMed Helper"
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
          />
          <button type="submit" className="pp-btn pp-coral pp-btn-compact">
            Send
          </button>
        </form>
        <p
          className="pp-detail-p"
          style={{ marginTop: 8, marginBottom: 0, color: "var(--pp-subtle)" }}
        >
          No audio — type or use the quick actions above.
        </p>
      </div>
    </>
  );
}